<template>
  <div>
    <el-row>
      <el-col>
        <el-alert
          effect="dark"
          show-icon
          :closable="false"
          title="Todos los clientes en esta lista estan exonerado del proceso de corte
        de servicio"
        ></el-alert>
      </el-col>
    </el-row>

    <div class="text-left">
      <p>
        Balance Pendiente :
        <span class="label label-danger" style="font-size: 22px">
          <template v-if="currency">
            {{ currency }}
          </template>
          <el-tag
            type="danger"
            effect="dark"
            v-if="sumaInvoiceCost"
            style="font-size: 22px; color: white"
            >{{ sumaInvoiceCost }}</el-tag
          >
          <el-tag
            type="danger"
            effect="dark"
            v-else
            style="font-size: 22px; color: white"
            >0.00</el-tag
          >
        </span>
      </p>
    </div>
    <rabbey-toolbox
      :filterables="true"
      :callNew="handleCallNew"
      @filter-search="handleSearch"
    ></rabbey-toolbox>
    <rabbey-table3
      :loading="loading"
      :columns="columns"
      :actions="actions"
      :data="renderItems"
      @rtable-push-action="handlePushAction"
    ></rabbey-table3>

    <el-dialog
      title="Selector de cliente"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <el-row>
        <el-col :span="24" :offset="0"
          ><el-alert
            title="Coloque el nombre o codigo del cliente para realizar la busqueda"
            type="info"
            effect="light"
            size="mini"
            show-icon
            :closable="false"
          ></el-alert
        ></el-col>
      </el-row>

      <el-row type="flex" justify="center" align="middle">
        <el-col :span="24">
          <el-select
            v-model="value"
            filterable
            remote
            reserve-keyword
            clearable
            size="small"
            placeholder="Por favor ingrese el nombre o codigo del cliente"
            style="width: 100%"
            :remote-method="remoteMethod"
            :loading="loading2"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
              <span class="text-truncate" style="float: left">{{
                item.label
              }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{
                item.value
              }}</span>
            </el-option>
          </el-select>
        </el-col>
      </el-row>

      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelDialog" size="mini">Cancel</el-button>
        <el-button type="primary" @click="confirmDialog" size="mini"
          >Confirm</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import DatetimeFormatterVue from "@/components/functionals/DatetimeFormatter.vue";
import { filterItems } from "@/utils";
import CelMoney from "@/components/functionals/CelMoney";
import ImagePerson from "@/components/functionals/ImagePerson.vue";

export default {
  name: "Exonerated",
  created() {
    this.getItems();
  },
  data() {
    return {
      search: "",
      sumaInvoiceCostUSD: 0.0,
      options: [],
      value: [],
      list: [],
      loading2: false,
      loading: false,
      columns: [
        {
          prop: "Id",
          label: "NO",
          width: 80,
          sortable: true,
          fixed: true
        },
        {
          prop: "clientCode",
          label: "Codigo",
          sortable: true,
          width: 150
        },
        {
          prop: "ClientName",
          label: "Nombre",
          minWidth: 250,
          sortable: true
        },
        {
          prop: "Invoices",
          label: "Cantidad de Factura",
          sortable: true,
          width: 150
        },
        {
          prop: "saldo",
          label: "Balance Pendiente",
          minWidth: 250,
          sortable: true,
          formatter: CelMoney
        },
        {
          prop: "EjecutivoCxc",
          label: "Cuenta por Cobrar",
          minWidth: 200,
          sortable: true,
          formatter: ImagePerson,
          attrs: {
            imgKey: "EjecutivoCxcPhoto"
          }
        },
        {
          prop: "Servicio",
          label: "Servicio al Cliente",
          sortable: true,
          width: 200,
          formatter: ImagePerson,
          attrs: {
            imgKey: "ServicioPhoto"
          }
        },
        {
          prop: "Vendedor",
          label: "Vendedor",
          minWidth: 200,
          sortable: true,
          formatter: ImagePerson,
          attrs: {
            imgKey: "VendedorPhoto"
          }
        },
        {
          prop: "createOn",
          label: "Fech. creacion",
          formatter: DatetimeFormatterVue,
          width: 150,
          sortable: true,
          "column-key": "createOn",
          "sort-by": "createOn"
        }
      ],
      items: [],
      actions: [{ command: "delete", label: "Eliminar" }],
      dialogVisible: false
    };
  },
  computed: {
    renderItems() {
      let i = filterItems(this.search, this.items, this.toggleLoading);
      return i;
    }
  },
  methods: {
    getItems() {
      this.loadig = true;
      this.$http
        .get("/api/ReconnectionAndExceptions/GetALLReconnectionAndExceptions", {
          params: { companyId: this.currentCompany }
        })
        .then(({ data }) => {
          this.items = data;
          this.sumaInvoiceCost = this.items.reduce(
            (total, item) => total + item.saldo,
            0
          );
          const formatoMonedaDominicana = new Intl.NumberFormat("es-DO", {
            style: "currency",
            currency: "DOP"
          });

          this.sumaInvoiceCost = formatoMonedaDominicana.format(
            this.sumaInvoiceCost
          );
        })
        .catch(console.error)
        .finally(() => (this.loadig = false));
    },
    handleSearch(s) {
      this.search = s;
    },
    handleCallNew() {
      this.dialogVisible = true;
    },
    remoteMethod(query) {
      if (query !== "" || !isNaN(query)) {
        this.loading2 = true;
        let params = {
          CompanyId: this.currentCompany,
          SalesPersonCode: null,
          CustomerService: null,
          Contract: null,
          AccountReceivable: null,
          Name: null,
          ClientId: null
        };

        const queryType = typeof query;
        if (queryType !== "string") {
          query = String(query);
        }

        if (query.toLowerCase().startsWith("cl")) {
          params.ClientId = query.toUpperCase();
        } else if (!isNaN(parseInt(query))) {
          params.ClientId = query;
        } else {
          params.Name = query;
        }

        this.$http
          .get("/api/customers?Page=1&Limit=10", { params })
          .then(({ data: { Items } }) => {
            this.options = Items.map((m) => ({
              label: m.Name,
              value: m.ClientCode,
              code: m.ClientCode
            }));
          })
          .finally(() => (this.loading2 = false));
      } else {
        this.options = [];
      }
    },
    cancelDialog() {
      this.dialogVisible = false;
      this.value = "";
    },
    confirmDialog() {
      if (this.value === "" || !isNaN(this.value)) {
        this.$message.error("Seleccione un cliente");
        return;
      }

      const client = this.options.find((f) => f.value === this.value);
      if (!client) {
        this.$message.error("Error al intentar registrar cliente.");
        return false;
      }

      const body = {
        clientCode: this.value,
        companyCode: this.currentCompany,
        ClientName: client.label
      };

      this.$http
        .post(
          "/api/ReconnectionAndExceptions/CreateReconnectionAndExceptions",
          body
        )
        .then((res) => {
          const index = this.items.findIndex(
            (f) => f.clientCode === res.data.clientCode
          );

          if (index === -1) {
            this.items.unshift(res.data);
            this.$message.success("Cliente agregado");
          } else {
            this.$message.success("Cliente ya fue agregado antes");
          }
        });
    },
    handlePushAction(action) {
      if (action.command === "delete") {
        this.$confirm(
          `Estas seguro de eliminar este registro ?
           Esta acciones permanente!`,
          "Advertencia",
          {
            confirmButtonText: "OK",
            cancelButtonText: "Cancel",
            type: "warning"
          }
        )
          .then(() => {
            this.loading = true;
            this.$http
              .delete(`/api/ReconnectionAndExceptions/${action.row.Id}`)
              .then(() => {
                const index = this.items.findIndex(
                  (f) => f.Id === action.row.Id
                );
                if (index > -1) {
                  this.items.splice(index, 1);
                }
              })
              .catch(console.error)
              .finally(() => (this.loading = false));
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "Eliminar cancelado"
            });
          });
      }
    },
    toggleLoading() {
      this.loading = !this.loading;
    }
  }
};
</script>
